import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { ErrorFacade } from './error.facade';
import { AppError } from './app-error';
import { ERROR_MAP } from './error-messages.const';
import { ErrorKey } from './error.model';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorFacade = inject(ErrorFacade);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        const errorType: ErrorKey =
          error.error?.error?.type in ERROR_MAP
            ? <ErrorKey>error.error?.error?.type
            : 'UNKNOWN_ERROR';
        const logMessage =
          error.error?.error?.message || error.error?.message || ERROR_MAP[errorType].logMessage;

        const appError = new AppError(errorType, logMessage, ERROR_MAP[errorType].uiMessage);

        if (error.status === 0 || error.status >= 500) {
          errorFacade.captureError(appError);
        }

        return throwError(() => appError);
      }

      return throwError(() => error);
    })
  );
};
